// src/stage2/characters/Stage2Characters.jsx
import React from "react";
import { useGLTF } from "@react-three/drei";
import NPCController from "./NPCController";

//////////////
// LIST OF NPC CHARACTERS
// "character traits" are contstructed in NPC Controller props
/////////////
const NPC_DEFS = [
  // AJ: stand still, cycles through multiple action GLBs
  {
    npcId: "aj",
    modelUrl: "/stageAssets/stage2/npcs/RandomBoy_AJ.glb",
    position: [-1, 0, -10],
    scale: 1,

    actionUrls: [
      "/stageAssets/stage2/npcActions/BreathingIdle.glb",
      "/stageAssets/stage2/npcActions/JumpingJacks.glb",
      "/stageAssets/stage2/npcActions/PushUp.glb",
      "/stageAssets/stage2/npcActions/Situps.glb",
    ],
    cycle: true,
    cycleSeconds: 6,

    orbColor: "#11631f",
    orbSize: 0.45,

    prompt: "Interact",
    onInteractText: "Want to excercise with me?",
    interactRadius: 2.5,
  },

  // Girl: seated, no path, no action (radius is -1)
  {
    npcId: "girl",
    modelUrl: "/stageAssets/stage2/npcs/RandomGirl_Claire.glb",
    position: [35.5, 3, -11.5],
    rotation: [0, Math.PI * 0.1, 0],
    scale: 1,

    actionUrls: ["/stageAssets/stage2/npcActions/SittingTalking.glb"],
    cycle: false,

    orbColor: "#7df4ff",
    orbSize: 0.3,

    prompt: "Talk",
    onInteractText: "Hi!",
    interactRadius: -1, // no interaction
  },

  // RandomBoy: moves in an oval loop (walking)
  {
    npcId: "randomBoy",
    modelUrl: "/stageAssets/stage2/npcs/RandomBoy_Ty.glb",
    position: [0, 0, 0],
    scale: 1,

    actionUrls: [
      "/stageAssets/stage2/npcActions/BreathingIdle.glb", // index 0 (idle)
      "/stageAssets/stage2/npcActions/Walking.glb",       // index 1 (default)
    ],
    cycle: false,
    idleIndex: 0, // when near, play the first item in the array (breathingIdle)
    startIndex: 1,

    orbColor: "#ffd36b",
    orbSize: 0.44,
    interactRadius: 2.82,
    prompt: "...Talk...",
    onInteractText: "I love riding bikes!",

    motion: {
      center: [2, 0, -9],
      shape: "oval",
      oval: [10.5, 2.5],
      speed: 0.03,
      phase: 0.22,
      faceLerp: 20,
      modelYawOffset: 0,
    },
  },

  // Teacher - Girl on Bench: seated, no path, single action
  {
    npcId: "teacherGirl",
    modelUrl: "/stageAssets/stage2/npcs/TeacherGirl_Elizabeth.glb",
    position: [-10.4,0.75,-0.5],
    rotation: [0, Math.PI * 0.9, 0],
    scale: 1.25,

    actionUrls: ["/stageAssets/stage2/npcActions/Sitting.glb"],

    //animation behavior
    cycle: true,
    cycleSeconds: 6,
    cycleDesyncSeconds: 0,

    // shadow orb look
    orbColor: "#c60ba0",
    orbSize: 0.3,

    // interaction
    prompt: "Talk to the teacher.",
    onInteractText: "The work of a healthy child is to PLAY! Children need encouragment for a job well done! Children need routine and predictablity.",
    interactRadius: 2,
  },
];

export function Stage2Characters({ playerPosRef }) {
  return (
    <group>
      {NPC_DEFS.map((def) => (
        <NPCController key={def.npcId} {...def} playerPosRef={playerPosRef} />
      ))}
    </group>
  );
}

// Preloads (optional but recommended)
useGLTF.preload("/stageAssets/stage2/npcs/RandomBoy_AJ.glb");
useGLTF.preload("/stageAssets/stage2/npcs/RandomGirl_Claire.glb");
useGLTF.preload("/stageAssets/stage2/npcs/RandomBoy_Ty.glb");
useGLTF.preload("/stageAssets/stage2/npcs/TeacherGirl_Elizabeth.glb");

useGLTF.preload("/stageAssets/stage2/npcActions/BreathingIdle.glb");
useGLTF.preload("/stageAssets/stage2/npcActions/JumpingJacks.glb");
useGLTF.preload("/stageAssets/stage2/npcActions/PushUp.glb");
useGLTF.preload("/stageAssets/stage2/npcActions/Situps.glb");
useGLTF.preload("/stageAssets/stage2/npcActions/Walking.glb");
useGLTF.preload("/stageAssets/stage2/npcActions/Sitting.glb");
useGLTF.preload("/stageAssets/stage2/npcActions/SittingTalking.glb");


